import { useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Tabs } from '@mantine/core';
import { ORGANIZATION_TAB, TAB_LABELS } from '@/types';
import { useTabStatusContext } from '@/hooks';
import styles from './ProgramTabs.module.sass';
import cx from 'clsx';

export const ProgramTabs = () => {
  const navigate = useNavigate();
  const { tabStatus, isLoading } = useTabStatusContext();

  const tabs = useMemo(() => Object.values(ORGANIZATION_TAB), []);
  const tab = useLocation().pathname.split('/').pop();
  const defaultTab = Object.values(ORGANIZATION_TAB).includes(tab as ORGANIZATION_TAB)
    ? tab
    : ORGANIZATION_TAB.ORG_ADMINS;
  const [activeTab, setActiveTab] = useState<ORGANIZATION_TAB>(defaultTab as ORGANIZATION_TAB);

  const handleChange = (next: string | null) => {
    setActiveTab(next as ORGANIZATION_TAB);
    navigate(`${next}`);
  };

  if (isLoading) {
    return (
      <Tabs radius="sm" value={activeTab} onChange={handleChange} color="orange">
        <Tabs.List grow>
          {tabs.map((t) => (
            <Tabs.Tab key={t} value={t} className={styles.tab} disabled>
              {TAB_LABELS[t as ORGANIZATION_TAB]}
            </Tabs.Tab>
          ))}
        </Tabs.List>
      </Tabs>
    );
  }

  return (
    <Tabs radius="sm" value={activeTab} onChange={handleChange} color="orange">
      <Tabs.List grow>
        {tabs.map((t) => {
          const isEnabled = tabStatus[t as ORGANIZATION_TAB];
          return (
            <Tabs.Tab key={t} value={t} className={cx(styles.tab, { [styles.enabled]: isEnabled })}>
              {TAB_LABELS[t as ORGANIZATION_TAB]}
            </Tabs.Tab>
          );
        })}
      </Tabs.List>
    </Tabs>
  );
};
